import { Fragment } from "react";
import type { JSX, ReactElement } from "react";

import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
} from "@frontend/components/atoms/ContextMenu";
import { Icon } from "@frontend/components/atoms/Icon";

import type { DataTableRowMenuItem } from "./DataTable.types";

interface DataTableRowMenuProps {
  items: DataTableRowMenuItem[];
  onSelect: (id: string) => void;
  children: ReactElement;
}

export function DataTableRowMenu({
  items,
  onSelect,
  children,
}: DataTableRowMenuProps): JSX.Element {
  return (
    <ContextMenu>
      <ContextMenuTrigger data-slot="data-table-row" render={children} />

      <ContextMenuContent>
        {items.map((item) => (
          <Fragment key={item.id}>
            {item.separatorBefore ? <ContextMenuSeparator /> : null}

            <ContextMenuItem
              disabled={item.disabled}
              onClick={() => onSelect(item.id)}
            >
              {item.icon ? <Icon name={item.icon} size="sm" /> : null}
              {item.label}
            </ContextMenuItem>
          </Fragment>
        ))}
      </ContextMenuContent>
    </ContextMenu>
  );
}
